import { createSelector } from '@ngrx/store';

import { createActionsWithReducer } from '../utils';
import { GenericCustomActionsCreator, GenericStoreCustomActions } from './types';

export interface GenericStoreOptions<State> {
  actions: GenericCustomActionsCreator<State>;
  initialState: State;
}

/**
 * Generic store without data adapter
 */
export const createGenericStore =
  <State extends object>() =>
  <StoreOptions extends GenericStoreOptions<State>>(namespace: string, options: StoreOptions) => {
    const baseSelector = createSelector(
      (root: any) => <State>root[namespace],
      state => state,
    );

    const { actions, reducer } = createActionsWithReducer(
      namespace,
      options.initialState,
      <GenericStoreCustomActions<StoreOptions>>options.actions(),
    );

    const selectors = {
      state: baseSelector,
    };

    return {
      namespace,
      selectors,
      actions,
      reducer,
    };
  };
